










import Vue from 'vue';
import LinkTitle from '@/components/LinkTitle.vue';

export default Vue.extend({
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  computed: {
    isValid(): boolean {
      const pattern = new RegExp('^(https?:\\/\\/)?'
          + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'
          + '((\\d{1,3}\\.){3}\\d{1,3}))'
          + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'
          + '(\\?[;&a-z\\d%_.~+=-]*)?'
          + '(\\#[-a-z\\d_]*)?$', 'i');
      return pattern.test(this.url);
    },
  },
  components: {
    'link-title': LinkTitle,
  },
});
